import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, ShoppingCart } from 'lucide-react';

const BOOK_SLUG = 'cultural-fluency-without-compromise';
const STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/6oUcN4etP3qP4kZfC38so01';

const BookPaymentCancelledPage = () => {
  return (
    <div className="min-h-screen bg-[#faf8f5] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-amber-600" />
          </div>
          <h1 className="text-2xl font-bold text-[#2c3e50] mb-2">Payment Cancelled</h1>
          <p className="text-[#5a6c7d] mb-8">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          
          <div className="space-y-3">
            <a
              href={STRIPE_PAYMENT_LINK}
              className="flex items-center justify-center gap-2 w-full bg-[#d4af37] text-[#2c3e50] px-6 py-3 rounded-lg font-semibold hover:bg-[#e5c349] transition-colors"
              data-testid="try-again-btn"
            >
              <ShoppingCart size={20} />
              Try Again – £9.99
            </a>
            <Link
              to={`/books/${BOOK_SLUG}`}
              className="flex items-center justify-center gap-2 w-full border-2 border-[#2c3e50] text-[#2c3e50] px-6 py-3 rounded-lg font-semibold hover:bg-[#2c3e50] hover:text-white transition-colors"
            >
              <ArrowLeft size={20} />
              Back to Book
            </Link>
          </div>
        </div>

        {/* Help Text */}
        <div className="text-center mt-8">
          <p className="text-sm text-[#5a6c7d]">
            Having trouble?{' '}
            <Link to="/support" className="text-[#d4af37] hover:underline">
              Contact Support
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookPaymentCancelledPage;
